module.exports = __webpack_public_path__ + "static/media/inspirationt.55c842a6.jpg";